import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Props } from 'shared/@types';
import { BreedAdvisor } from 'shared/components/breed-advisor';
import { BreedAdvisorConversationContent } from 'shared/components/breed-advisor-conversation';
import { BreedAdvisorHistory } from 'shared/components/breed-advisor-history';
import { PageContent } from 'shared/components/page-content';
import { Platform } from 'react-native';
import type { AdvisorTranslate } from 'shared/library/breed-advisor';
import { useBreedAdvisor } from 'shared/library/use-breed-advisor';

interface CreateBreedMatchScreenProps extends Props {}
const CreateBreedMatchScreen = ({}: CreateBreedMatchScreenProps) => {
  const { t } = useTranslation('components');
  const copy = useCallback<AdvisorTranslate>(
    (key, values) => t(`breed_advisor.${key}`, values),
    [t],
  );
  const advisor = useBreedAdvisor(copy);

  return (
    <PageContent
      nativeSafeTop={true}
      className={Platform.OS === 'web' ? '!p-0 lg:!px-6 lg:!py-12' : undefined}
    >
      <BreedAdvisor
        footer={
          advisor.hydrated &&
          advisor.history.length > 0 && (
            <BreedAdvisorHistory
              history={advisor.history}
              activeId={advisor.activeHistoryId}
              disabled={advisor.status === 'loading'}
              copy={copy}
              onOpen={(id) => {
                void advisor.openHistory(id);
                if (Platform.OS === 'web')
                  document
                    .getElementById('hundrasexperten')
                    ?.scrollIntoView({ behavior: 'smooth' });
              }}
              onRemove={advisor.removeHistory}
            />
          )
        }
      >
        <BreedAdvisorConversationContent advisor={advisor} copy={copy} />
      </BreedAdvisor>
    </PageContent>
  );
};
export { CreateBreedMatchScreen };
export type { CreateBreedMatchScreenProps };
